module.exports = __webpack_public_path__ + "static/media/D9D269C6-E10E-406D-80E8-540E19E4C3B9.53b2516d.jpg";